import { render, staticRenderFns } from "./password_update.vue?vue&type=template&id=61fbff3e&scoped=true&"
import script from "./password_update.vue?vue&type=script&lang=js&"
export * from "./password_update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fbff3e",
  null
  
)

export default component.exports